import type { TFunction } from "i18next";
import type { EmailInviteDto } from "../../autogen/bff-api";

export const orgRemovalText = (organizationName: string | undefined, inChange: boolean, t: TFunction) => {
  if (inChange) {
    return organizationName
      ? t("{{organization}} is removed when you send the change. Until then it keeps its access.", {
          organization: organizationName,
        })
      : t("The organization is removed when you send the change. Until then it keeps its access.");
  }
  return organizationName
    ? t("{{organization}} loses access to the event.", { organization: organizationName })
    : t("The organization loses access to the event.");
};

export const emailInviteRemovalText = (
  invite: EmailInviteDto,
  inChange: boolean,
  t: TFunction,
) => {
  const email = invite.email;
  const organization = invite.organizationEntry?.name;
  if (inChange) {
    return organization
      ? t(
          "{{email}} is removed from the invitation to {{organization}} when you send the change. Until then the address keeps its access.",
          { email, organization },
        )
      : t(
          "{{email}} is removed from the invitation when you send the change. Until then the address keeps its access.",
          {
            email,
          },
        );
  }
  return organization
    ? t("{{email}} is removed from the invitation to {{organization}}.", {
        email,
        organization,
      })
    : t("{{email}} is removed from the invitation.", { email });
};
